module.exports = __webpack_public_path__ + "static/media/038-cape-verde.437fcb6c.svg";